import * as inspectionTemplates from 'serviceWorker/db/inspectionTemplates/inspectionTemplates';
import * as inspectionTemplatesService from 'serviceWorker/db/inspectionTemplates/inspectionTemplatesService';
import { getOne as getPermissionOnProject } from 'serviceWorker/db/permissions';
import {
  fetchInspectionTemplates,
  fetchUpdatedInspectionTemplates,
} from './fetchInspectionTemplates';

import { Services } from 'shared/domain/messages/message';
import { broadcastAllInspectionTemplates } from 'serviceWorker/broadcasts/inspectionTemplates';
import { UserRole } from 'shared/types/userRole';
import { get as getSelectedProject } from 'serviceWorker/db/selectedProject';

import { inspectionTemplateContract } from 'shared/domain/inspectionTemplate/inspectionTemplateContract';
import { createSyncedEntity } from '../factories/createSyncedEntity';

/**
 * Download and sync of the inspectionTemplates; the source's `sync` is its entry point.
 */
export const inspectionTemplatesSync = createSyncedEntity({
  entityName: Services.INSPECTION_TEMPLATES,
  contract: inspectionTemplateContract,
  repository: inspectionTemplates,
  service: inspectionTemplatesService,
  fetch: fetchInspectionTemplates,
  fetchUpdated: fetchUpdatedInspectionTemplates,
  publishCollection: broadcastAllInspectionTemplates,
  canSynchronize: canSyncTemplates,
});


/** Standard users have no access to templates: nothing is downloaded for them. */
export async function canSyncTemplates(): Promise<boolean> {
  const selectedProject = await getSelectedProject();
  if (!selectedProject) {
    return false;
  }
  const currentProjectPermissions = await getPermissionOnProject(
    selectedProject._id
  );
  if (!currentProjectPermissions) {
    return false;
  }

  return currentProjectPermissions.role !== UserRole.standard;
}
